"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPascalCase = void 0;
const toPascalCase = function (words) {
    return words.
        map((word) => `${word[0].toUpperCase()}${word.slice(1)}`).
        join('');
};
exports.toPascalCase = toPascalCase;
